import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { IMediaTranscoderRepository } from '../../../../domain/media-transcoder/media-transcoder.repository';

@Injectable({ providedIn: 'root' })
export class PackagerSideEffectsGuard {
  constructor(
    private _mediaTranscoderRepository: IMediaTranscoderRepository,
    private _router: Router,
  ) {}

  async canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Promise<boolean> {
    const sideEffects = await this._mediaTranscoderRepository.getSideEffects();
    if (sideEffects.length > 0) {
      return true;
    }

    await this._router.navigate(['/media-transcoder/jobs/active']);
    return false;
  }
}
